import { useParams } from "react-router"
import API from ".";
import { getToken } from "../utils"


/** H5登录 做统一硬编码登录已获取token */
export function login({username,password}:{username:string;password:string}) {
    const formData = new FormData();

  formData.append('username', username);
  formData.append('password', password);
    return API.post('/User/Login',formData);
}

/** 获取用户信息
 */
export function fetUserInfo(id:string) {
    return API.get(`/User/userInfo?id=${id}`,{headers:{token:getToken()}});
}

/** 获取用户头像 */ 
export function getUserIcon(fileId:string) {
    return API.get(`/Annexes/FileInfo?fileId=${fileId}`,{headers:{token:getToken()}});
}

/** 获取商家的信息 */
export function fetchStoreInfo(id:string) {
    return API.get(`/Company/Info?companyId=${id}`,{headers:{token:getToken()}})
}

/** 获取信息库具体信息  */
export function fetchEquipInfo(id:string) {
    return API.get(`/InformationBase/Info?informationBaseId=${id}`,{headers:{token:getToken()}})
}

/** 发送验证码 */
export function sendCode(phone:string) {
    return API.get(`/Member/SendCode?phone=${phone}`,{headers:{token:getToken()}})
}

/** 保存用户 */
export function saveVipMember(params:object) {
    return API.post(`/Member/save`,params,{headers:{token:getToken()}})
}
